module.exports = __webpack_public_path__ + "static/media/republicofkorea.3ab3b44b.svg";